import type * as React from 'react';

/** A combobox trigger's keydown handler: ArrowDown opens it, as Enter and Space already do, by clicking it while it is closed. */
export function openComboboxOnArrowDown(event: React.KeyboardEvent<HTMLElement>): void {
  if (event.key !== 'ArrowDown' || event.currentTarget.getAttribute('aria-expanded') === 'true') {
    return;
  }
  event.preventDefault();
  event.currentTarget.click();
}
